import CRUDgeneric from 'utils/CRUDgeneric';
import API from 'utils/api';
import { onError } from 'utils/handlers';

// Defino a donde el cliente consumira los enpoints.
export const urlAgregarVacacionesFechas = '/nominas/vacaciones-empleados-dias-disfrutados-fechas-agregar/';
export const fechasName = 'fechas';
export const numeroDiasName = 'dias_habiles_disfrutados';
const _cliente = CRUDgeneric('/nominas/vacaciones-empleados-dias-disfrutados-fechas/');
// El nombre del modelo que aparecera al agregar y editar.
const _nameModel = 'Fechas de Vacaciones Disfrutadas';
// El nombre del modelo para mencionar al nombre del registro.
const _nameModelSingular = 'Las Fechas de Vacaciones Disfrutadas';

// Formatea el registro antes insertarlo al form.
const _formatRecordForRead = (record) => record;
// Formatea el registro antes de enviarlo al backend.
const _formatRecordForSend = (record) => record;

// Empaqueto todo en un objeto
export const ModelVacacionesRegistrosFechas = {
  cliente: _cliente,
  nameModel: _nameModel,
  nameModelSingular: _nameModelSingular,
  formatter: {
    formatRecordForRead: _formatRecordForRead,
    formatRecordForSend: _formatRecordForSend,
  },
};

/**
 * GET Vacaciones Empleado Dias Disfrutados Fechas
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getVacacionesRegistrosFechas = async (params) => (
  _cliente.obtenerListaDeRegistros(params)
);

/**
 * GET Fechas que el empleado ya tiene registradas como Guardia.
 * Se usan para bloquear esos días en el calendario de Registro de Vacaciones,
 * ya que un mismo día no puede ser a la vez Vacación disfrutada y Guardia.
 * @param {number} empleado
 * @returns {Promise<string[]>}
 */
export const getFechasOcupadasPorGuardia = async (empleado) => {
  if (!empleado) return [];
  try {
    const response = await API.get('/nominas/registro-dias-guardia-fechas-ocupadas/', {
      params: { empleado },
    });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Fechas que el empleado ya tiene registradas como Vacación disfrutada en OTROS
 * registros (Activo o Autorizado). Se usan para bloquear esos días en el propio
 * calendario de Registro de Vacaciones, ahora que un empleado puede tener varios
 * registros con el mismo Año de Vacaciones y Periodo Vacacional: dos registros no
 * pueden compartir la misma fecha. Se excluye el registro que se está editando para
 * no bloquear sus propias fechas ya guardadas.
 * @param {number} empleado
 * @param {number} [excluirVacacionEmpleadoDiaDisfrutadoId]
 * @returns {Promise<string[]>}
 */
export const getFechasOcupadasPorVacacion = async (
  empleado,
  excluirVacacionEmpleadoDiaDisfrutadoId,
) => {
  if (!empleado) return [];
  try {
    const response = await API.get('/nominas/vacaciones-empleados-dias-disfrutados-fechas-ocupadas/', {
      params: {
        empleado,
        excluir_vacacion_empleado_dia_disfrutado_id: excluirVacacionEmpleadoDiaDisfrutadoId,
      },
    });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};
